/* LIBRAIRIES */
import React, { Fragment, useState, useEffect } from 'react';

/* FIREBASE */
import { getStorage, ref, deleteObject } from 'firebase/storage';

/* COMPONENTS */
import ModalPicture from '../ModalPicture/ModalPicture';
import CustomAlert from '../CustomAlert/CustomAlert';

/* LOADER */
import { Oval } from 'react-loader-spinner';

/* ASSETS */
import DeleteBtn from '../../Assets/DeleteBtn/DeleteBtn';
import ModifyBtn from '../../Assets/ModifyBtn/ModifyBtn';
import ViewBtn from '../../Assets/ViewBtn/ViewBtn';

/* MUI */
import Box from '@mui/material/Box';
import { DataGrid, gridClasses, GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { alpha, styled } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

/* ICONS */
import { MdDeleteForever } from 'react-icons/md';
import { BsFillFileEarmarkPdfFill } from 'react-icons/bs';

/* CSS */ 
import './DataGridMedias.css';

//-----------------------------STRIPED DATA-GRUD-----------------------------//
//--------------------------------------------------------------------------//
const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[200],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
            theme.palette.action.selectedOpacity +
            theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));

//-----------------------------SEARCH FILTER-----------------------------//
//----------------------------------------------------------------------//
function QuickSearchToolbar() {
  return (
    <GridToolbarContainer sx={{ p: '5px 10px' }}>
      <GridToolbarQuickFilter placeholder='Rechercher'/>
    </GridToolbarContainer>
  );
}

export default function QuickFilteringCustomizedGrid({ refreshDocs, setRefreshDocs, userId, userMedias, composant }) {
    console.log(composant)

    const [pageSize, setPageSize] = useState(100);
    const [isModalPictureOpen, setIsModalPictureOpen] = useState(false);
    const [selectedImageUrl, setSelectedImageUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success");
    const [alertMessage, setAlertMessage] = useState("");
    const [sortedUserMedias, setSortedUserMedias] = useState([]);
    const isMobile = useMediaQuery('(max-width: 500px)'); // Condition pour écran mobile

    const sortDataByDateCreated = (data) => {
        const sortedData = [...data];
        sortedData.sort((a, b) => {
          const dateA = new Date(a.dateCreated);
          const dateB = new Date(b.dateCreated);
          return dateB - dateA; // Tri décroissant (du plus récent au moins récent)
        });
        return sortedData;
      };

    function handleOpenModalPicture(url) {
        setSelectedImageUrl(url);
        setIsModalPictureOpen(true);
    }
    
    function handleCloseModalPicture() {
        setIsModalPictureOpen(false);
    }

    function handleDelete(mediaId) {
        setIsLoading(true);
        const storage = getStorage();
        const storageRef = ref(storage, `medias/${userId}/${mediaId}`);
        deleteObject(storageRef)
            .then(() => {
                console.log(`File ${mediaId} deleted successfully`);
                setRefreshDocs(!refreshDocs);
                setAlertSeverity("success");
                setAlertMessage("Le fichier a été supprimé avec succès !");
                setOpenAlert(true);
                // Refresh your data after deletion
            })
            .catch((error) => {
                console.error(`Error deleting file ${mediaId}: ${error}`);
                setAlertSeverity("error");
                setAlertMessage("Erreur lors de la suppression du fichier. Veuillez réessayer.");
                setOpenAlert(true);
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    const handleCloseAlert = () => {
        setOpenAlert(false);
    }

    useEffect(() => {
        // Tri des données initiales
        const sortedData = sortDataByDateCreated(userMedias);
        setSortedUserMedias(sortedData);
      }, [userMedias]);

//-----------------------------COLUMN SETTINGS-----------------------------//
//------------------------------------------------------------------------//
const columns = [
    { 
        field: 'dateCreated', 
        headerName: "Date d'envoie", 
        flex: 1,
        renderCell: (params) => (
            <div>
                <p>{new Date(params.row.dateCreated).toLocaleDateString()}</p>
                <p>{new Date(params.row.dateCreated).toLocaleTimeString()}</p>
            </div>
        )
    },
    { field: 'titre', headerName: 'Titre Doc', flex: 1 },
    { field: 'firstName', headerName: "Nom", flex: 1.5,
        renderCell: (params) => (
            <div>{params.row.firstName} {params.row.name}</div>
        )
    },
    { field: 'apercu', headerName: 'Apercu', flex: 1,
        renderCell: (params) => (
            params.row.contentType.includes('pdf') ? (
              <div style={{cursor: 'pointer', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <a href={params.row.url} target="_blank" rel="noreferrer"><BsFillFileEarmarkPdfFill size={30}/></a>
              </div>
            ) : (
              <div onClick={() => handleOpenModalPicture(params.row.url)} style={{cursor: 'pointer', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <img loading='lazy' src={params.row.url} alt={params.row.id} style={{width: "100px"}} />
              </div>
            )
          )
    }, 
    {
        field: 'Actions',
        headerName: 'Actions', 
        flex: 1,
        renderCell: (params) => (
            <div style={{display: 'flex', justifyContent: 'center', gap: "5px", width: "100%" }} className="actions-column">
                {
                    isLoading ?
                    <Oval
                        height={25}
                        width={25}
                        color="var(--primary)"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel='oval-loading'
                        secondaryColor="#4fa94d"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                        />
                    :
                    <MdDeleteForever size={30} onClick={() => handleDelete(params.row.id)} className='btnDelete'/>
                }
            </div> 
        ) 
      } 
];
//-----------------------------------------------------

    return (
        <Fragment>
        { userMedias !== undefined &&
            <Box sx={{ height: "100%", width: "100%", position: "relative"}}>
              <StripedDataGrid
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                  }
                  sx={{ color: 'black', borderColor: '#ccc' }}
                  rows={sortedUserMedias}
                  getRowId={(row) => row.id}
                  columns={
                    isMobile
                      ? columns.filter(
                          (col) =>
                            col.field !== 'name' &&
                            col.field !== 'firstName' &&
                            col.field !== 'Actions'
                        )
                      : composant === 'modal'
                      ? columns.filter((col) => col.field !== 'Actions')
                      : columns
                  }                  disableColumnFilter
                  disableColumnSelector
                  disableDensitySelector
                  pageSize={pageSize}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  components={{ Toolbar: QuickSearchToolbar}} 
              />
                {isModalPictureOpen && <ModalPicture url={selectedImageUrl} onClose={handleCloseModalPicture} />}
            </Box>
        }
        <CustomAlert 
            open={openAlert}
            onClose={handleCloseAlert}
            message={alertMessage}
            severity={alertSeverity}
        />
        </Fragment>
    );
}